(function ($, Drupal, once) {
  Drupal.behaviors.dnrwMenuInit = {
    attach: function (context, settings) {

      // Navigation initial sichtbar machen
      once('dnrwMenuInitShowMenu', '.main-nav', context).forEach(function (el) {
        setTimeout(function () {
          el.classList.remove('d-none');
        }, 500);
      });

      // Hamburger-Menü-Button (Mobil)
      once('dnrwMenuInitHamburger', '.hamburger--collapse', context).forEach(function (el) {
        el.addEventListener('click', function () {
          el.classList.toggle('collapsed');
          const nav = context.querySelector('.main-nav');
          if (nav) {
            nav.classList.toggle('show');
            if (nav.classList.contains('show')) {
              nav.classList.remove('d-none');
            }
          }
        });
      });

      // Klick auf normale Navigationspunkte schließt Mobilmenü
      once('dnrwMenuInitNavItem', '.nav-item:not(.dropdown)', context).forEach(function (el) {
        el.addEventListener('click', function () {
          const mainCollapse = document.querySelector('#main-collapse');
          const navbarToggle = document.querySelector('.navbar-toggle');
          if (mainCollapse) {
            mainCollapse.classList.remove('show');
          }
          if (navbarToggle) {
            navbarToggle.classList.add('collapsed');
          }
        });
      });

    }
  };
})(jQuery, Drupal, once);

(function (Drupal, once) {
  Drupal.behaviors.clickableDropdownLinks = {
    attach(context) {

      once('clickableDropdownLinks', '.nav-item.dropdown', context)
        .forEach((parentLi) => {

          const toggleBtn = parentLi.querySelector('.submenu-toggle');
          const mainLink = parentLi.querySelector('a.dropdown-toggle');
          const mainNavList = parentLi.closest('.navbar-nav');
          const secondLevelMenu = document.querySelector('.second-level-menu');

          if (!toggleBtn || !mainLink) return;

          // Bootstrap-Instanz an das Button-Element hängen
          const dropdownInstance = bootstrap.Dropdown.getOrCreateInstance(toggleBtn, {
            reference: parentLi
          });

          // Event 1: Sobald ein Dropdown ÖFFNET
          parentLi.addEventListener('show.bs.dropdown', function () {
            parentLi.classList.add('dropdown-open');

            if (mainNavList) {
              mainNavList.classList.add('submenu-is-open');
            }
            if (secondLevelMenu) {
              secondLevelMenu.classList.add('submenu-is-open');
            }
            toggleBtn.setAttribute('aria-expanded', 'true');
          });

          // Event 2: Sobald ein Dropdown SCHLIESST
          parentLi.addEventListener('hidden.bs.dropdown', function () {
            parentLi.classList.remove('dropdown-open');
            toggleBtn.setAttribute('aria-expanded', 'false');

            if (mainNavList) {
              setTimeout(() => {
                const anyOpen = mainNavList.querySelectorAll('.dropdown-menu.show').length > 0;
                if (!anyOpen) {
                  mainNavList.classList.remove('submenu-is-open');
                  if (secondLevelMenu) {
                    secondLevelMenu.classList.remove('submenu-is-open');
                  }
                }
              }, 50);
            }
          });

          // Funktion zum Schließen aller anderen Menüs
          function closeOtherDropdowns() {
            if (mainNavList) {
              const openToggles = mainNavList.querySelectorAll('.submenu-toggle[aria-expanded="true"]');
              openToggles.forEach((openToggle) => {
                if (openToggle !== toggleBtn) {
                  const otherDropdown = bootstrap.Dropdown.getInstance(openToggle);
                  if (otherDropdown) {
                    otherDropdown.hide();
                  }
                }
              });
            }
          }

          // 1. TEXT-LINK INTERVENTION ENTFERNT
          // Wir binden keinen Klick-Handler mehr an 'mainLink'.
          // Er verhält sich jetzt wie ein ganz normaler HTML-Link und leitet sofort weiter.

          // 2. KLICK-HANDLER FÜR DEN PFEIL (BUTTON)
          toggleBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            if (!parentLi.classList.contains('dropdown-open')) {
              closeOtherDropdowns();
              dropdownInstance.show();
            } else {
              dropdownInstance.hide();
            }
          });

        });

      // GLOBALER LISTENER: Schließen bei Klick außerhalb
      once('dropdownOutsideClick', 'html', context).forEach((html) => {
        document.addEventListener('click', function (e) {
          const openToggles = document.querySelectorAll('.navbar-nav .submenu-toggle[aria-expanded="true"]');

          openToggles.forEach((openToggle) => {
            const parentLi = openToggle.closest('.dropdown');
            if (parentLi && !parentLi.contains(e.target)) {
              const dropdownInstance = bootstrap.Dropdown.getInstance(openToggle);
              if (dropdownInstance) {
                dropdownInstance.hide();
              }
            }
          });
        });
      });
    },
  };

  'use strict';

  Drupal.behaviors.stickySecondLevelMenu = {
    attach: function (context, settings) {
      const menus = once('sticky-second-level-menu', '.second-level-menu', context);

      menus.forEach((menu) => {
        const offsetTop = menu.offsetTop;

        window.addEventListener('scroll', () => {
          if (window.scrollY > offsetTop) {
            menu.classList.add('is-sticky');
          } else {
            menu.classList.remove('is-sticky');
          }
        });
      });
    }
  };

})(Drupal, once);
